(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:email', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                url: 'api/users/:email/email',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'deactivate': {
                method: 'GET',
                url: 'api/users/:email/deactivate'

            },
            'activate': {
                method: 'GET',
                url: 'api/users/:email/activate'

            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{
                method:'DELETE',
                url: 'api/users/:email/email'
            },
            'importContacts':{
                method:'POST',
                url: 'api/import/profiles/linkedin',
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            },
            'mySuperior': {
                method: 'GET',
                isArray: false,
                url: 'api/users/mySuperior'
            },
            'sameSuperior': {
                method: 'GET',
                isArray: true,
                url: 'api/users/sameSuperior'
            },
            'getProfilePicture': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    var profile = data[0];
                    return ['data:' + profile.pictureContentType + ';base64,' + profile.picture];
                },
                url: 'api/profiles?email=:email'
            },
            'search': {
                method: 'GET',
                url: 'api/users/search/:query',
                isArray: true
            },

            'updateMyEquipeCommerciale':{
                method:'PUT',
                url: 'api/users/updateMyEquipeCommerciale',
            },
        });

        return service;
    }
})();
